export { default } from './MuiThemeProvider';
